import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
    const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 py-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
              
               
                <div style={{ display: "flex", gap: "15px" }}>
                    <div style={{ flex: 1 }}>
                      <label htmlFor=""   style={{ fontSize: "0.8rem" }}>Transaction Date</label>
                       <input
                    type="date"
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem" }}
                  
                    value={ getToday()}
                  
                  />
                    </div>
                  <div style={{ flex: 1 }}>

                    <SelectSearch
                      list={CompanyList}
                      label="Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>

               
             
                </div>
                   <div className="col-6 width-50"  style={{ display: "flex", gap: "15px" }}>
             
                  <div  style={{ flex: 1 }}>

                    <SelectSearch
                      list={CompanyList}
                      label="Closing Account Head"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("ClosingAccountHead", val)}
                      placeholder=""
                    />
                  </div>

               
             
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#E3F5DF",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Fiscal Year"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.ClosingAccountHead}
                      onChange={(val) =>
                        handleChange("ClosingAccountHead", val)
                      }
                    />
                  </div>
          
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: "0.8rem" }}>Period Start Date</label>
                    <input
                      type="date"
                      className="form-control tableinput noborder"
                      style={{ fontSize: "0.8rem" }}
                      value={getToday()}
                    />
                  </div>
          
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: "0.8rem" }}>Period End Date</label>
                    <input
                      type="date"
                      className="form-control tableinput noborder"
                      style={{ fontSize: "0.8rem" }}
                      value={getToday()}
                    />
                  </div>
                </div>
          
                {/* Row 2 */}
                 <div className="col-9">
                   <label style={{ fontSize: "0.8rem" }}>Remarks</label>
                   <textarea
                     className="form-control tableinput noborder"
                     rows={2}
                     style={{ fontSize: "0.8rem" }}
                     value={pageState.Remarks || ""}
                     onChange={(e) =>
                       handleChange("Remarks", e.target.value)
                     }
                     placeholder="Enter remarks"
                   />
                 </div>
               </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
